(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    const productCardWishlistStorageKey = 'raza-gems-wishlist';
  const getProductCardWishlist = () => JSON.parse(localStorage.getItem(productCardWishlistStorageKey) || '[]');
  const setProductCardWishlist = (wishlist) => localStorage.setItem(productCardWishlistStorageKey, JSON.stringify(wishlist));

  const syncProductCardWishlistButtons = () => {
    const wishlist = getProductCardWishlist();

    document.querySelectorAll('[data-product-card-wishlist]').forEach((button) => {
      const active = wishlist.some((item) => item.handle === button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-card-wishlist]');

    if (!button) return;

    const wishlist = getProductCardWishlist();
    const product = {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      variantId: button.dataset.productVariantId,
      color: button.dataset.productColor,
      shape: button.dataset.productShape,
      type: button.dataset.productGemstoneType,
      gemstoneType: button.dataset.productGemstoneType,
      productType: button.dataset.productType,
    };
    const existingIndex = wishlist.findIndex((item) => item.handle === product.handle);

    if (existingIndex > -1) {
      wishlist.splice(existingIndex, 1);
    } else {
      wishlist.unshift(product);
    }

    setProductCardWishlist(wishlist);
    syncProductCardWishlistButtons();
    window.dispatchEvent(new CustomEvent('raza-gems:wishlist-updated', { detail: { count: wishlist.length } }));
  });

  syncProductCardWishlistButtons();
  window.addEventListener('raza-gems:wishlist-updated', syncProductCardWishlistButtons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const shareButton = event.target.closest('.gemstone-purchase-tools__share');

    if (!shareButton) return;

    const shareData = {
      title: shareButton.dataset.shareTitle,
      url: shareButton.dataset.shareUrl,
    };

    if (navigator.share) {
      navigator.share(shareData);
      return;
    }

    if (navigator.clipboard && shareData.url) {
      navigator.clipboard.writeText(shareData.url);
    }
  });

  const wishlistStorageKey = 'raza-gems-wishlist';
  const getWishlist = () => JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
  const setWishlist = (wishlist) => localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlist));

  const updateWishlistButton = (button, isSaved) => {
    const label = button.querySelector('[data-wishlist-label]');
    button.classList.toggle('is-active', isSaved);

    if (label) {
      label.textContent = isSaved
        ? button.dataset.wishlistAddedLabel
        : button.dataset.wishlistAddLabel;
    }
  };

  document.querySelectorAll('[data-wishlist-add]').forEach((button) => {
    const wishlist = getWishlist();
    updateWishlistButton(button, wishlist.some((item) => item.handle === button.dataset.productHandle));
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-add]');
    if (!button) return;

    event.preventDefault();

    const product = {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      variantId: button.dataset.productVariantId,
      color: button.dataset.productColor,
      shape: button.dataset.productShape,
      type: button.dataset.productGemstoneType,
      gemstoneType: button.dataset.productGemstoneType,
      productType: button.dataset.productType,
    };

    if (!product.handle) return;

    const wishlist = getWishlist();
    const existingIndex = wishlist.findIndex((item) => item.handle === product.handle);
    const isSaved = existingIndex === -1;

    if (existingIndex >= 0) {
      wishlist.splice(existingIndex, 1);
    } else {
      wishlist.unshift(product);
    }

    setWishlist(wishlist);
    updateWishlistButton(button, isSaved);
    window.dispatchEvent(
      new CustomEvent('raza-gems:wishlist-updated', {
        detail: {
          count: wishlist.length,
          saved: isSaved,
          handle: product.handle,
        },
      })
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gemstone-details"] && !Shopify.designMode) return;
  try {
    const updateGemstoneViewers = () => {
    document.querySelectorAll('[data-gemstone-viewer]').forEach((viewer) => {
      const text = viewer.querySelector('[data-gemstone-viewer-text]');
      if (!text) return;

      const min = Number.parseInt(viewer.dataset.viewerMin, 10) || 1;
      const max = Math.max(Number.parseInt(viewer.dataset.viewerMax, 10) || min, min);
      const productId = viewer.dataset.productId || window.location.pathname;
      const bucket = Math.floor(Date.now() / 180000);
      const seed = `${productId}-${bucket}`;
      let hash = 0;

      for (let index = 0; index < seed.length; index += 1) {
        hash = (hash * 31 + seed.charCodeAt(index)) >>> 0;
      }

      const count = min + (hash % (max - min + 1));
      text.textContent = (viewer.dataset.viewerText || '').replace('__COUNT__', count);
    });
  };

  updateGemstoneViewers();
  document.addEventListener('shopify:section:load', updateGemstoneViewers);
  } catch(e) { console.error(e); }
})();

})();
